:host {
    display: flex;
    flex-direction: column;
    padding: 15px 10px;
    border-inline-end: 1px solid #9ea9b0;
    border-block-end: 1px solid #9ea9b0;
    grid-column: auto / span var(--ux-cell-span);
    gap: 0 10px;
    position: relative;
}

:host([borderless]) {
    border: 0;
}

::slotted(ux-copy) {
    margin-block-start: 0;
    margin-block-end: 0;
}

:host([sortable]) {
    cursor: pointer;
}

:host([head]) {
    flex-direction: row;
    text-transform: uppercase;
    background-color: #c3cfd6;

    #labelContainer {
        @container style(--trumpf-ux-theme: web) {
            align-items: end;
        }

        align-items: normal;
    }

    overflow: hidden;
}

:host([sorted][head]) {
    #labelContainer {
        border-color: black;
    }
}

#labelContainer {
    display: flex;
    align-items: center;
    gap: 0 10px;
    padding-block-start: 5px;
    padding-block-end: 5px;
    border-block-end: 1px solid transparent;
}

:host(:not([head]):hover) {
    background-color: var(--ux-table-col-hover-color, #f0f0f0);
}

:host([loading]) {
    #loadingContainer {
        display: block;
    }
}

#loadingContainer {
    height: 100%;
    min-height: 20px;
    align-self: center;
    display: none;
    --loader-background-color: #EEEEEE;
    --loader-highlight-color: #DEDEDE;
    background: linear-gradient(90deg, var(--loader-background-color) 25%, var(--loader-highlight-color) 50%, var(--loader-background-color) 75%);
    background-size: 200% 100%;
    animation: loading 2s infinite ease-in-out;
    width: 100%;
}

@keyframes loading {
    0% {
        background-position: 200% 0;
    }

    100% {
        background-position: -200% 0;
    }
}